var $c7df6686b4189d56$exports = {};
$c7df6686b4189d56$exports = {
  "ascending": "augo\u0161\u0101 sec\u012Bb\u0101",
  "ascendingSort": function ascendingSort(args) {
    return "k\u0101rtots p\u0113c kolonnas ".concat(args.columnName, " augo\u0161\u0101 sec\u012Bb\u0101");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pikse\u013Ci");
  },
  "descending": "dilsto\u0161\u0101 sec\u012Bb\u0101",
  "descendingSort": function descendingSort(args) {
    return "k\u0101rtots p\u0113c kolonnas ".concat(args.columnName, " dilsto\u0161\u0101 sec\u012Bb\u0101");
  },
  "resizerDescription": "Nospiediet Enter, lai s\u0101ktu izm\u0113ru main\u012B\u0161anu",
  "select": "Atlas\u012Bt",
  "selectAll": "Atlas\u012Bt visu",
  "sortable": "k\u0101rtojam\u0101 kolonna"
};
export { $c7df6686b4189d56$exports as default };